import { useParams } from "react-router-dom";
import SummerCampMultiPlayerForm from "../../Components/SummerCampRegisterForm/RegisterForm2/SummerCampMultiPlayerForm";
import RegistrationForm from "../../Components/SummerCampRegisterForm/RegisterFrom1/RegisterForm";
import "./summercamp.css";
import { useNewUser } from "../../APIContext/NewUserContext";
import { useEffect } from "react";
import Loader from "../../Components/Loader/Loader";

const SummerCampRegisterPage = () => {
  const { id, user } = useParams();
  const { loading, getSummerCampList, summercampList } = useNewUser();

  useEffect(() => {
    getSummerCampList();
  }, []);

  if (loading) {
    return <Loader />;
  }

  console.log(user, "user");

  return (
    <div className="summer-camp-container">
      <div className="summer-camp-header">
        <h1 className="header-title">BASKETBALL SUMMER CAMPS</h1>

        <div className="header-right">
          <div className="contact-pill bg-custom">
            <span className="contact-label text-clip">Text us</span>
            <a href="tel:6464507572" className="contact-number text-clip">
              646-450-7572
            </a>
          </div>
        </div>
      </div>

      <div
        // style={{ filter: "brightness(1.28)" }}
        className="form-container bg-custom"
      >
        {user === "authenticated" ? (
          <SummerCampMultiPlayerForm
            offeringId={id}
            summercampList={summercampList}
          />
        ) : (
          <RegistrationForm offeringId={id} summercampList={summercampList} />
        )}
      </div>
    </div>
  );
};

export default SummerCampRegisterPage;
